import { zodResolver as _zodResolver } from '@hookform/resolvers/zod'
import type { ZodType } from 'zod'
import type { Resolver, FieldValues } from 'react-hook-form'

// @hookform/resolvers v5 + Zod v4: resolver returns 3-generic Resolver<Input,Ctx,Output>
// which is incompatible with useForm<Output>. This wrapper casts it back to Resolver<T>.
export function zodResolver<T extends FieldValues>(
  schema: ZodType<T, FieldValues>,
): Resolver<T> {
  return _zodResolver(schema) as unknown as Resolver<T>
}
